import { Eye, Filter, Plus } from 'lucide-react';
import { useLanguage } from '../../../../contexts/LanguageContext';

interface EmptyStateProps {
  type: 'no-items' | 'no-matches';
  onAddClick?: () => void;
  onClearFilter?: () => void;
}

export function EmptyState({ type, onAddClick, onClearFilter }: EmptyStateProps) {
  const { t } = useLanguage();

  if (type === 'no-matches') {
    return (
      <div className="bg-white border border-gray-200 rounded-2xl p-12 text-center">
        <div className="w-16 h-16 rounded-2xl bg-gray-100 flex items-center justify-center mx-auto mb-4">
          <Filter className="w-8 h-8 text-gray-400" />
        </div>
        <h2 className="text-lg font-semibold text-gray-900">
          {t('watchlist.noMatches.title', 'No Matches')}
        </h2>
        <p className="text-gray-600 mt-2 max-w-sm mx-auto">
          {t('watchlist.noMatches.description', 'No items match your search. Try a different search term.')}
        </p>
        {onClearFilter && (
          <button
            onClick={onClearFilter}
            className="mt-4 px-4 py-2 text-sm font-medium text-primary-600 hover:text-primary-700 hover:bg-primary-50 rounded-xl transition-colors"
          >
            {t('watchlist.clearFilter', 'Clear Filter')}
          </button>
        )}
      </div>
    );
  }

  return (
    <div className="bg-white border border-gray-200 rounded-2xl p-12 text-center">
      <div className="w-16 h-16 rounded-2xl bg-primary-100 flex items-center justify-center mx-auto mb-4">
        <Eye className="w-8 h-8 text-primary-600" />
      </div>
      <h2 className="text-lg font-semibold text-gray-900">
        {t('watchlist.empty.title', 'Your watchlist is empty')}
      </h2>
      <p className="text-gray-600 mt-2 max-w-sm mx-auto">
        {t('watchlist.empty.description', 'Add products to track their prices and get notified about availability changes.')}
      </p>
      {onAddClick && (
        <button
          onClick={onAddClick}
          className="mt-4 inline-flex items-center gap-2 px-5 py-2.5 text-sm font-medium text-white bg-primary-600 rounded-xl hover:bg-primary-700 transition-colors shadow-sm"
        >
          <Plus className="w-4 h-4" />
          {t('watchlist.addFirst', 'Add your first product')}
        </button>
      )}
    </div>
  );
}
